<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'ActionLabel',

    functional: true,

    props: {
        action: {type: Object, default: null},
        hideIcon: {type: Boolean},
        hideBadges: {type: Boolean},
        largeIcon: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        const children = props.hideBadges
            ? null
            : [
                (props.action && props.action.needs_reason)
                    ? [
                        ' ',
                        createElement('span', {
                            staticClass: 'badge badge-secondary',
                        }, [parent.$t('actions.badges.needs-reason')]),
                    ]
                    : null,

                (props.action && props.action.has_schedule)
                    ? [
                        ' ',
                        createElement('span', {
                            staticClass: 'badge badge-info',
                        }, [parent.$t('actions.badges.has-schedule')]),
                    ]
                    : null,

                (props.action && props.action.conditions_count === 0)
                    ? [
                        ' ',
                        createElement('span', {
                            staticClass: 'badge badge-danger',
                        }, [parent.$t('actions.badges.no-criteria')]),
                    ]
                    : null,
            ];

        const iconClass = 'fa fa-fw fa-bullseye' + (props.largeIcon ? ' fa-lg' : '');

        data.props = {
            item: props.action,
            hideIcon: props.hideIcon,
            iconClass: iconClass,
            none: parent.$t('actions.nil'),
        };

        return createElement(DataLabel, data, children);
    },
};
</script>
